import React from 'react'
import { Typography } from '@material-ui/core'
import { CampaignType } from '../../../../constants/marketingCampaign'
import { CampaignDefinition } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { GlobalDiscountRuleState } from './types'
import { validateGlobalDiscountRule } from './validate'
import { buildGlobalDiscountFormValues } from './buildFormValues'
import { GlobalDiscountRuleStep } from './RuleStep.view'
import { GlobalDiscountConfirmationSummary } from './ConfirmationSummary.view'

const ruleDescription = (
	<Typography variant="body2" style={{ color: '#616161', marginBottom: 14, lineHeight: 1.65 }}>
		Lorsque le panier atteint le <strong style={{ color: '#212121' }}>montant minimum</strong>, une{' '}
		<strong style={{ color: '#212121' }}>réduction en pourcentage</strong> s&apos;applique à l&apos;ensemble
		des produits de la carte concernée.
	</Typography>
)

function getInitialRuleFromCampaign(campaign: any): GlobalDiscountRuleState {
	return {
		discount: campaign.config?.discount?.value ?? null,
		threshold: campaign.config?.threshold ?? null,
	}
}

export const globalProductDiscountDefinition: CampaignDefinition<GlobalDiscountRuleState> = {
	type: CampaignType.GLOBAL_PRODUCT_DISCOUNT_AFTER_THRESHOLD,
	RuleStep: GlobalDiscountRuleStep,
	ConfirmationSummary: GlobalDiscountConfirmationSummary,
	defaultRule: { discount: null, threshold: null },
	validateRule: validateGlobalDiscountRule,
	buildFormValues: buildGlobalDiscountFormValues,
	ruleDescription,
	getInitialRuleFromCampaign,
	confirmationLimitPolicy: 'none',
	showOrderTypesInConfirmation: true,
	forceDeliveryOrderType: false,
	allowsPermanent: true,
}
